export enum routePathName {
	loading = 'loading',
	account = 'account',
	dashboard = 'dashboard',
	apiDocumentation = 'api-documentation',
	support = 'support',
	users = 'users',
	registrations = 'registrations',
	apps = 'apps',
	resetPassword = 'reset',
	signIn = 'login',
	oauthCallback = 'oauth/callback'
}

export const routeUrl = (path: string): string[] => {
	return ['/' + path];
};
